import con from '../../../connection';
var path = '/login';
var login = function (url) { return function () { return ({
    post: function (param, noError) {
        if (noError === void 0) { noError = false; }
        return con.post(url + path, param, noError);
    },
}); }; };
export default login;
